"use client";

import CasesServices from "@/components/Services/CasesServices/CasesServices";
import { CommentCarousel } from "@/components/Services/CommentCarousel/CommentCarousel";
import { Hero } from "@/components/Services/Hero/Hero";
import InnovationWaveText from "@/components/Services/InnovationWaveText/InnovationWaveText";
import OurServices from "@/components/Services/OurServices/OurServices";
import { WhyChooseUs } from "@/components/Services/WhyChooseUs/WhyChooseUs";
import { ExcellenceAwards } from "@/components/common/ExcellenceAwards/ExcellenceAwards";
import { Footer } from "@/components/layout/Footer/Footer";
import { useRef } from "react";
import styles from "./Section.module.scss";

import IsologoTransition from "@/components/common/IsologoTransition/IsologoTransition";
import { useGsapBurgerTimeline } from "@/utils/useGsapBurgerTimeline";
import ExpertiseAreas from "@/components/Services/ExpertiseAreas/ExpertiseAreas";

const SectionServices = ({ texts }) => {
  const ourServicesRef = useRef(null);

  useGsapBurgerTimeline({
    triggerClass: styles.transitionContainer,
    endAdjustment: -128,
  });

  return (
    <section className="services-wrap" style={{ overflow: "hidden" }}>
      <Hero messages={texts.serviceHero} />
      <section className={styles.transitionContainer}>
        <IsologoTransition />
        <ExpertiseAreas messages={texts.expertiseSection} />
        <InnovationWaveText messages={texts.innovationTitle} />
      </section>
      <OurServices messages={texts.ourServices} ref={ourServicesRef} />
      <WhyChooseUs messages={texts.chooseUs} />
      <CommentCarousel testimonies={texts.testimonies} />
      <ExcellenceAwards messages={texts.awardsSection} isFastTitleAnimation />
      <CasesServices
        messages={texts.successTitle}
        projectsList={texts.projectsList}
      />
      <Footer />
    </section>
  );
};

export default SectionServices;

SectionServices.displayName = "SectionServices";
